import { Form, Modal } from "antd";
import React, { FC, ReactNode } from "react";

type ModalItemProps = {
  title: ReactNode;
  show: boolean;
  onCloseModal: () => void;
  children?: ReactNode;
  className?: string; // Thêm prop className
};

const ModalItem: FC<ModalItemProps> = ({
  title,
  show,
  onCloseModal,
  children,
  className = "modal-width",
}) => {
  return (
    <Modal
      title={title}
      open={show}
      onCancel={onCloseModal}
      centered
      closable
      footer={null}
      className={className}
    >
      <div>{children}</div>
    </Modal>
  );
};

export default ModalItem;
